/**
* @author 贝才[beica1@outook.com]
* @date 2021/3/3
* @description
*   TheCreateCost.vue of WeTrade
*/
<template>
<t path="placeorder_17" class="c-text f-bold mr-10">Total Cost</t>
<money class="f-lg f-bold" :class="`c-${themeClass}`" :v="order.cost.value" />
</template>

<script lang="ts">
import Order from '@/modules/trade/Order'
import { defineComponent, inject } from 'vue'

export default defineComponent({
  name: 'TheTradeCost',
  setup () {
    const themeClass = inject<string>('themeClass')
    const order = inject('order') as Order

    return {
      themeClass,
      order,
    }
  },
})
</script>
